export default {
  namespaced: true,
  state: {
    couponCodes: [],
    count: 0,
  },
  getters: {
    couponCodes: (state) => state.couponCodes,
    count: (state) => state.count,
  },
  mutations: {
    couponCodes: (state, payload) => (state.couponCodes = payload),
    count: (state, payload) => (state.count = payload),
  },
  actions: {
    list({ commit }, queryParams) {
      return this.$apiService
        .get("/coupon-codes", {
          params: queryParams,
        })
        .then((res) => {
          commit("couponCodes", res?.data?.data ?? []);
          commit("count", res?.data?.total ?? 0);
          return res;
        });
    },
    create({}, payload) {
      return this.$apiService.post("/coupon-codes", payload);
    },
    show({}, id) {
      return this.$apiService.get(`/coupon-codes/${id}`);
    },
    getHistory({}, { id, data }) {
      return this.$apiService.get(`/coupon-history/${id}`, { params: data });
    },
    update({}, { id, data }) {
      return this.$apiService.put(`/coupon-codes/${id}`, data);
    },
    destroy({}, id) {
      return this.$apiService.delete(`/coupon-codes/${id}`);
    },
  },
};
